import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/hooks/useAuth";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user && user.role === "admin") navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bone flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <p className="overline text-center">Elvis Beauty</p>
        <h1 className="editorial-h text-4xl text-center mt-3 text-brand-dark">Admin sign in</h1>
        <p className="font-sans text-sm text-brand-muted text-center mt-2">
          Manage products, reps, leads & routines.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4 bg-white border border-brand-line p-6">
          <div>
            <Label className="font-sans text-xs uppercase tracking-widest text-brand-dark">Email</Label>
            <Input
              type="email"
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 h-12 rounded-none border-brand-line bg-white focus-visible:ring-brand-primary focus-visible:border-brand-primary"
              placeholder="admin@elvisbeauty.com"
            />
          </div>
          <div>
            <Label className="font-sans text-xs uppercase tracking-widest text-brand-dark">Password</Label>
            <Input
              type="password"
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 h-12 rounded-none border-brand-line bg-white focus-visible:ring-brand-primary focus-visible:border-brand-primary"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-none bg-brand-primary hover:bg-brand-primaryHover text-brand-bone font-semibold tracking-wide"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="font-sans text-xs text-brand-muted text-center mt-6">
          Customer funnel: <a href="/" className="text-brand-primary underline">/</a>
        </p>
      </div>
    </div>
  );
}
